import React from 'react';

import cx from 'classnames';

import { useStoredState } from 'lane-shared/hooks';
import { UserType } from 'lane-shared/types/User';

import ChannelSelectorButton from './ChannelSelectorButton';
import UserSearchOnChannel from './UserSearchOnChannel';

import styles from './UserSelector.scss';

type OwnProps = {
  className?: string;
  style?: React.CSSProperties;
  channelId?: string;
  onUserSelected: (
    user: UserType | null,
    selectedChannel: string | null
  ) => void;
  disableChannelSelect: boolean;
  disableStorage?: boolean;
  includeWorkplaceMember: boolean;
  storageKey?: string;
};

type Props = OwnProps;

export default function UserSelector({
  className,
  style,
  channelId,
  onUserSelected = () => null,
  disableChannelSelect = false,
  disableStorage = false,
  includeWorkplaceMember = false,
  storageKey,
}: Props) {
  const [selectedChannel, setSelectedChannel] = useStoredState<
    string | undefined | null
  >(`UserSelector${storageKey}`, channelId, { disableStorage });

  return (
    <div className={cx(styles.UserSelector, className)} style={style}>
      <section>
        {!disableChannelSelect && (
          <ChannelSelectorButton
            className={styles.selectorButton}
            channelId={selectedChannel}
            storageKey={`UserSelector${storageKey}ChannelSelectorButton`}
            onChannelSelected={(channel: any) =>
              setSelectedChannel((channel && channel._id) || null)
            }
            disableStorage={disableStorage}
          />
        )}

        {selectedChannel && (
          <UserSearchOnChannel
            className={styles.userSearch}
            storageKey={`UserSelector${storageKey}UserSearchOnChannel`}
            channelId={selectedChannel}
            onUserSelected={onUserSelected}
            disableStorage={disableStorage}
            includeWorkplaceMember={includeWorkplaceMember}
          />
        )}
      </section>
    </div>
  );
}
